var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.clinic_config.enable_customer_levels)?_c('div',{staticClass:"customer-level",style:(_vm.style),attrs:{"data-toggle":"tooltip","title":_vm.name}},[(_vm.name != '')?_c('img',{attrs:{"src":_vm.icon_url,"alt":_vm.name}}):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }